import ReactDOM from "react-dom/client";

import App from "./App.tsx";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);

// if ("serviceWorker" in navigator && import.meta.env.MODE !== "production") {
//   navigator.serviceWorker.register("/dev-sw.js?dev-sw", {
//     type: "module",
//   });
// }
